"use client";
import { useMemo } from "react";
import { motion } from "framer-motion";
import { getScrollAnimation } from "@/utils/getScrollAnimation";

const CTA = ({
  title,
  text,
  buttonText,
  onClick,
}: {
  title: string;
  text?: string;
  buttonText: string;
  onClick: () => void;
}) => {
  const scrollAnimation = useMemo(() => getScrollAnimation(), []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.3 }}
      className="bg-[#EFFAF6] border-[7px] border-green rounded-3xl "
    >
      <div className="p-8 py-20 text-center text-black">
        <h3 className="text-3xl font-semibold mb-4 ">{title}</h3>
        <p className="mb-6 max-w-3xl mx-auto">{text}</p>
        <motion.button
          onClick={onClick}
          variants={scrollAnimation}
          className="bg-black md:w-[280px] shadow-md text-white px-5 py-3 rounded-full text-lg hover:bg-green/90 transition-colors"
        >
          {buttonText}
        </motion.button>
      </div>
    </motion.div>
  );
};

export default CTA;
